export const navigateSelectFirstOption = (vm, index) => {
  if (vm && vm.$refs && vm.$refs[`remoteSelect${index}`] && vm.$refs[`remoteSelect${index}`].navigateOptions) {
    // kye-select
    vm.$refs[`remoteSelect${index}`].navigateOptions('next')
  } else if (vm && vm.navigateOptions) {
    // el-select
    vm.navigateOptions('next')
  }
}


export function isEmptyArray (val) {
  return Array.isArray(val) && !val.length
}



// WEBPACK FOOTER //
// ./src/public/components/kye-employee/utils/tools.js